import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import "./Header.scss";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProfileAvatar from "../Profile";
import { logoutUser } from "../../redux/slices/authSlice";
import { useDispatch } from "react-redux";

const Header = ({ explainationButton }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutRedirectUrl = localStorage.getItem("logout_redirect_url");

  const first_name = localStorage.getItem("first_name");
  const last_name = localStorage.getItem("last_name");

  const handleLogout = () => {
    dispatch(logoutUser(navigate));
  };

  return (
    <Box className="header-container">
      <Box className="header-left">
        <span className="dashboard-title">
          MRAgent LLM Engagement Dashboard
        </span>
      </Box>

      <Box className="header-right">
        <IconButton
          aria-label="delete"
          sx={{ padding: 0 }}
          onClick={handleLogout}
        >
          {logoutRedirectUrl ? (
            <Tooltip title="Back to Home" arrow>
              <HomeIcon />
            </Tooltip>
          ) : (
            <LogoutIcon />
          )}
        </IconButton>

        {/* Info Button */}
        <Tooltip title="Metric Info" arrow>
          <IconButton
            onClick={explainationButton}
            sx={{
              height: "32px",
              width: "40px",
            }}
          >
            <InfoOutlineIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Tooltip>
        <ProfileAvatar name={first_name} surname={last_name} />
      </Box>
    </Box>
  );
};

export default Header;
